// extracted by mini-css-extract-plugin
module.exports = {"EditButton":"PartList_EditButton__2lCxr"};